<template>
  <generic-historical 
    :get-detalle="getDetalleAux"
    :get-pag="getPagAux"
    :get-excel="getExcelAux"
    :get-params="getParamsAux"
    :get-params-detalle="getParamsDetalleAux"
    :excel-name="ExcelName"
    :id-vista="idVista"
    :header-url="headerUrl"
    :breadcrumbs="breadcrumbs"
    :vuexnamespace="vuexnamespace" />
</template>

<script>
import _ from 'lodash'
import { i18n } from '@/i18n'
import GenericHistorical from '@/views/historical/GenericHistorical.vue'
import { getRegistroVerifactuDetail } from '@/services/verifactu/getRegistroVerifactuDetail'
import { getHistoricalByVerifactu } from '@/services/historical/getHistoricalByVerifactu'
import { getHistoricalByVerifactuExcel } from '@/services/historical/getHistoricalByVerifactuExcel'
export default {
  name: 'list-tax-historical',
  components: {
    GenericHistorical
  },
  data: function () {
    return {
      idVista: 96,
      vuexnamespace: 'historicalVerifactu',
      headerUrl: 'verifactu/details',
      breadcrumbs: [],
      ExcelName: `${_.kebabCase(i18n.t('verifactu.register') + i18n.t('historical.entity_name'))}.xlsx`,
    }
  },
  computed: {
    idCliente: function () {
      return parseInt(this.$route.params.IdCliente)
    },
    idCifEmpresa: function () {
      return parseInt(this.$route.params.IdCifEmpresa)
    },
    numSerieFactura: function () {
      return this.$route.params.NumSerieFactura
    },
    fechaExpedicion: function () {
      return this.$route.params.FechaExpedicion.split('T')[0]
    },
    CSVZC: function () {
      return this.$route.params.CSVZC
    },
    idEstado: function () {
      return parseInt(this.$route.params.type)
    },
    tiposEstadoVerifactu: function () {
      return this.$store.getters['config/TIPOS_ESTADO_VERIFACTU']
    },
    nombreEstado: function () {
      return this.tiposEstadoVerifactu.find(x => x.id === this.idEstado)?.Nombre ?? ''
    },
  },
  mounted () {
    this.breadcrumbs = [
      { url: 'verifactu', name: i18n.t('verifactu.header') },
      { url: `/verifactu/${this.idEstado}`, name: this.nombreEstado },
      { paths: ['NumSerieFactura'], routeCallback: (data) => ({ path: '', name: data?.NumSerieFactura ?? data }) },
    ]
  },
  methods: {
    getParamsAux: function (data) {
      return {
        idCliente: this.idCliente,
        idCifEmpresa: this.idCifEmpresa,
        NumSerieFactura: this.numSerieFactura,
        fechaExpedicion: this.fechaExpedicion,
        CSVZCHistorico: this.CSVZC,
      }
    },
    getParamsDetalleAux: function (data) {
      return this.getParamsAux(data)
    },
    getDetalleAux: async function (params) {
      return await getRegistroVerifactuDetail(params)
    },
    getExcelAux: async function (payload, params) {
      return await getHistoricalByVerifactuExcel(payload, params)
    },
    getPagAux: async function (payload, params) {
      return await getHistoricalByVerifactu(payload, params)
    },
  }
}
</script>

<style lang="scss" scoped></style>
